import { useState } from 'react';
import { RequestARecruiterModal } from '@carcareers/components';
import { Button } from '@mui/material';

export const RecruiterAssistedPostingHelp = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button onClick={handleOpenModal} variant="contained" color="primary">
        Ask a Recruiter
      </Button>
      <RequestARecruiterModal open={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};
